import { render, staticRenderFns } from "./CopyFrom.vue?vue&type=template&id=47936099"
import script from "./CopyFrom.vue?vue&type=script&lang=js"
export * from "./CopyFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports